import { render, staticRenderFns } from "./AddNewVacation.vue?vue&type=template&id=a05bcb32&scoped=true"
import script from "./AddNewVacation.vue?vue&type=script&lang=ts"
export * from "./AddNewVacation.vue?vue&type=script&lang=ts"
import style0 from "./AddNewVacation.vue?vue&type=style&index=0&id=a05bcb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05bcb32",
  null
  
)

export default component.exports